import {Box, Heading, PageLayout} from '@primer/react'
import type {PropsWithChildren} from 'react'

type LayoutProps = {
  title: string
}

export default function Layout({children, title}: PropsWithChildren<LayoutProps>) {
  return (
    <PageLayout rowGap="none">
      <PageLayout.Header divider="line" sx={{mb: 3}}>
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <Heading as="h1" sx={{fontSize: 4, fontWeight: 'normal', pb: 2}} id="commits-pagehead">
            {title}
          </Heading>
        </Box>
      </PageLayout.Header>

      <PageLayout.Content as="div">
        <Box>{children}</Box>
      </PageLayout.Content>
    </PageLayout>
  )
}

try{ Layout.displayName ||= 'Layout' } catch {}